<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AvlaTV/tc-custom/9781617755460.jpg?1700071225905" alt="This image is the cover for the book Discretion"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Discretion
      </h1>
      <p class="bookDescription body article font2">
        <b>“A captivating tale of Oufoula Sindede, an African diplomat in a passionless marriage who falls madly in love with Marguerite, a New York City artist.” —<i>Essence</i></b><br/>  <br/> Dutifully married to lovely Nerida, Oufoula goes through the motions, formally keeping his distance from the woman with whom he shares his bed. And yet there is a deeper, buried passion within him that will lead him to question which values he holds sacred and which can be sacrificed.<br/>  <br/> Despite his quiet marriage, the memory of a fiery love affair triggers Oufoula to entangle himself in the life of another woman, a Jamaican-born painter named Marguerite. Soon he discovers that Marguerite is nothing like his quick old flames or his gentle wife, Nerida—Marguerite is much more.<br/>  <br/> And so begins a whirlwind affair, spanning over twenty years, between a young woman who wants order and love and a man who is torn between the honors of his profession and his dishonorable love life; the old African customs of polygamy and the American dream; the passion for a mistress and the duty to a wife.<br/>  <br/> “A provocative new love story.” —<i>The Seattle Times</i><br/>  <br/> “Refreshingly ambitious in its intellectual scope.” —<i>The New York Times Book Review</i><br/>  <br/> “Right from the start of this haunting novel, Nunez adopts the mesmerizing myth-spinning voice of an oral storyteller . . . Nunez explores self-deception, envy, Christian monogamy vs. African polygamy, and the very real dilemma of loving two people at once.” —<i>Publishers Weekly</i><br/>  <br/> “A complex portrait of a love triangle by a gifted writer.” —<i>Booklist</i><br/>  <br/><i>A main selection of the Black Expressions Book Club</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Nunez
      </h2>
      
      <p class="authorDescription body article"><B>Elizabeth Nunez</B> is the award-winning author of a memoir and nine novels, four of them selected as <I>New York Times</I> Editors' Choice. Her two most recent books are <I>Not for Everyday Use</I>, a memoir, which won the 2015 prestigious Hurston Wright Legacy Award for nonfiction, and the novel <I>Even in Paradise</I>, a contemporary version of Shakespeare's <I>King Lear</I>. Her other novels are: <I>Boundaries</I> (nominated for the 2012 NAACP Image Award for Outstanding Literary Fiction); <I>Anna In-Between</I> (PEN Oakland Award for Literary Excellence and long-listed for an IMPAC Dublin International Literary Award); <I>Prospero's Daughter</I> (2010 Trinidad and Tobago One Book, One Community selection, and the 2006 Florida Center for the Literary Arts One Book, One Community); <I>Bruised Hibiscus</I> (American Book Award); <I>Beyond the Limbo Silence</I> (Independent Publishers Book Award); <I>Grace</I>; <I>Discretion</I>; and <I>When Rocks Dance</I>. Nunez received her PhD from New York University and is a Distinguished Professor at Hunter College, CUNY, where she teaches courses on Caribbean Women Writers and Creative Writing.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Akashic Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?75917dee